$(function() {
	//検索ボタン
	$('#site-search-sidebar .search-more').hide();
	$("#search-form-sidebar").keyup(function(){
	  if($(this).val()){
	  	$('#site-search-sidebar .search-more').show();
	  }
	  else{
	  	$('#site-search-sidebar .search-more').hide();
	  }
	});
	$('#site-search-sidebar .search-more').click(function(){
		var url = $('#search-form-sidebar').val();
		window.location.href = "/search?q="+ url;
	});	

	$(window).scroll(function() {
		var elem = $('.js-move');
		elem.each(function () {
			var elemOffset = $(this).offset().top;
			var scrollPos = $(window).scrollTop();
			var wh = $(window).height();

			if(scrollPos > elemOffset - wh + (wh / 6) ){
			  $(this).addClass("active");
			}
		});

	});
  $('.loaded').addClass('active');
	$(window).on('load resize', function() {
	});
	
	
	//メガメニュー
	$(".site-nav.style--classic .js-mega-menu-item:nth-child(2) .submenu.mega-menu .with-promotion #mega-link1").after('<div class="mega-link-wrap"></div>');
	$(".site-nav.style--classic .js-mega-menu-item:nth-child(2) .submenu.mega-menu .with-promotion #mega-link2").appendTo(".mega-link-wrap");
	$(".site-nav.style--classic .js-mega-menu-item:nth-child(2) .submenu.mega-menu .with-promotion #mega-link3").appendTo(".mega-link-wrap");
	$(".site-nav.style--classic .js-mega-menu-item:nth-child(2) .submenu.mega-menu .with-promotion #mega-link4").appendTo(".mega-link-wrap");
	/*$(".site-nav.style--classic .js-mega-menu-item:nth-child(2) .submenu.mega-menu .with-promotion #mega-link5").appendTo(".mega-link-wrap");*/
	
	//$('.site-nav.style--classic .js-mega-menu-item:nth-child(2) .submenu.mega-menu .mega-link.has-promotion').wrapAll('<div class="has-promotion-wrap">');
    
	//fix-headerにコピー
    $('.sticky-header .header__bottom').html($('#site-header #header-top').clone());
})


$(document).ready(function() {
  var checkResize;
  $(window).on('load resize', function() {
      clearTimeout( checkResize );
      checkResize = setTimeout( resizing, 100 );
  });

  //リサイズ完了時に実行する処理
  function resizing() {
    //メガメニューの位置合わせ
	var megamenuoffsetLeft = $('.link-list .js-mega-menu-item:first-child .menu-link').offset().left;
	$(".site-nav.style--classic .js-mega-menu-item:nth-child(1) .submenu.mega-menu .submenu-holder").css({
		"margin-left":megamenuoffsetLeft
	});	
  }
});